const nationality = [
  {
    name: `Afghanistan`,
    dialCode: `+93`,
    isoCode: `AF`,
    flag: `🇦🇫`,
  },
  {
    name: `Aland Islands`,
    dialCode: `+358`,
    isoCode: `AX`,
    flag: `🇦🇽`,
  },
  {
    name: `Albania`,
    dialCode: `+355`,
    isoCode: `AL`,
    flag: `🇦🇱`,
  },
  {
    name: `Algeria`,
    dialCode: `+213`,
    isoCode: `DZ`,
    flag: `🇩🇿`,
  },
  {
    name: `AmericanSamoa`,
    dialCode: `+1684`,
    isoCode: `AS`,
    flag: `🇦🇸`,
  },
  {
    name: `Andorra`,
    dialCode: `+376`,
    isoCode: `AD`,
    flag: `🇦🇩`,
  },
  {
    name: `Angola`,
    dialCode: `+244`,
    isoCode: `AO`,
    flag: `🇦🇴`,
  },
  {
    name: `Anguilla`,
    dialCode: `+1264`,
    isoCode: `AI`,
    flag: `🇦🇮`,
  },
  {
    name: `Antarctica`,
    dialCode: `+672`,
    isoCode: `AQ`,
    flag: `🇦🇶`,
  },
  {
    name: `Antigua and Barbuda`,
    dialCode: `+1268`,
    isoCode: `AG`,
    flag: `🇦🇬`,
  },
  {
    name: `Argentina`,
    dialCode: `+54`,
    isoCode: `AR`,
    flag: `🇦🇷`,
  },
  {
    name: `Armenia`,
    dialCode: `+374`,
    isoCode: `AM`,
    flag: `🇦🇲`,
  },
  {
    name: `Aruba`,
    dialCode: `+297`,
    isoCode: `AW`,
    flag: `🇦🇼`,
  },
  {
    name: `Ascension Island`,
    dialCode: `+247`,
    isoCode: `AC`,
    flag: `🇦🇨`,
  },
  {
    name: `Australia`,
    dialCode: `+61`,
    isoCode: `AU`,
    flag: `🇦🇺`,
  },
  {
    name: `Austria`,
    dialCode: `+43`,
    isoCode: `AT`,
    flag: `🇦🇹`,
  },
  {
    name: `Azerbaijan`,
    dialCode: `+994`,
    isoCode: `AZ`,
    flag: `🇦🇿`,
  },
  {
    name: `Bahamas`,
    dialCode: `+1242`,
    isoCode: `BS`,
    flag: `🇧🇸`,
  },
  {
    name: `Bahrain`,
    dialCode: `+973`,
    isoCode: `BH`,
    flag: `🇧🇭`,
  },
  {
    name: `Bangladesh`,
    dialCode: `+880`,
    isoCode: `BD`,
    flag: `🇧🇩`,
  },
  {
    name: `Barbados`,
    dialCode: `+1246`,
    isoCode: `BB`,
    flag: `🇧🇧`,
  },
  {
    name: `Belarus`,
    dialCode: `+375`,
    isoCode: `BY`,
    flag: `🇧🇾`,
  },
  {
    name: `Belgium`,
    dialCode: `+32`,
    isoCode: `BE`,
    flag: `🇧🇪`,
  },
  {
    name: `Belize`,
    dialCode: `+501`,
    isoCode: `BZ`,
    flag: `🇧🇿`,
  },
  {
    name: `Benin`,
    dialCode: `+229`,
    isoCode: `BJ`,
    flag: `🇧🇯`,
  },
  {
    name: `Bermuda`,
    dialCode: `+1441`,
    isoCode: `BM`,
    flag: `🇧🇲`,
  },
  {
    name: `Bhutan`,
    dialCode: `+975`,
    isoCode: `BT`,
    flag: `🇧🇹`,
  },
  {
    name: `Bolivia`,
    dialCode: `+591`,
    isoCode: `BO`,
    flag: `🇧🇴`,
  },
  {
    name: `Bosnia and Herzegovina`,
    dialCode: `+387`,
    isoCode: `BA`,
    flag: `🇧🇦`,
  },
  {
    name: `Botswana`,
    dialCode: `+267`,
    isoCode: `BW`,
    flag: `🇧🇼`,
  },
  {
    name: `Brazil`,
    dialCode: `+55`,
    isoCode: `BR`,
    flag: `🇧🇷`,
  },
  {
    name: `British Indian Ocean Territory`,
    dialCode: `+246`,
    isoCode: `IO`,
    flag: `🇮🇴`,
  },
  {
    name: `Brunei Darussalam`,
    dialCode: `+673`,
    isoCode: `BN`,
    flag: `🇧🇳`,
  },
  {
    name: `Bulgaria`,
    dialCode: `+359`,
    isoCode: `BG`,
    flag: `🇧🇬`,
  },
  {
    name: `Burkina Faso`,
    dialCode: `+226`,
    isoCode: `BF`,
    flag: `🇧🇫`,
  },
  {
    name: `Burundi`,
    dialCode: `+257`,
    isoCode: `BI`,
    flag: `🇧🇮`,
  },
  {
    name: `Cambodia`,
    dialCode: `+855`,
    isoCode: `KH`,
    flag: `🇰🇭`,
  },
  {
    name: `Cameroon`,
    dialCode: `+237`,
    isoCode: `CM`,
    flag: `🇨🇲`,
  },
  {
    name: `Canada`,
    dialCode: `+1`,
    isoCode: `CA`,
    flag: `🇨🇦`,
  },
  {
    name: `Cape Verde`,
    dialCode: `+238`,
    isoCode: `CV`,
    flag: `🇨🇻`,
  },
  {
    name: `Cayman Islands`,
    dialCode: `+1345`,
    isoCode: `KY`,
    flag: `🇰🇾`,
  },
  {
    name: `Central African Republic`,
    dialCode: `+236`,
    isoCode: `CF`,
    flag: `🇨🇫`,
  },
  {
    name: `Chad`,
    dialCode: `+235`,
    isoCode: `TD`,
    flag: `🇹🇩`,
  },
  {
    name: `Chile`,
    dialCode: `+56`,
    isoCode: `CL`,
    flag: `🇨🇱`,
  },
  {
    name: `China`,
    dialCode: `+86`,
    isoCode: `CN`,
    flag: `🇨🇳`,
  },
  {
    name: `Christmas Island`,
    dialCode: `+61`,
    isoCode: `CX`,
    flag: `🇨🇽`,
  },
  {
    name: `Cocos (Keeling) Islands`,
    dialCode: `+61`,
    isoCode: `CC`,
    flag: `🇨🇨`,
  },
  {
    name: `Colombia`,
    dialCode: `+57`,
    isoCode: `CO`,
    flag: `🇨🇴`,
  },
  {
    name: `Comoros`,
    dialCode: `+269`,
    isoCode: `KM`,
    flag: `🇰🇲`,
  },
  {
    name: `Congo`,
    dialCode: `+242`,
    isoCode: `CG`,
    flag: `🇨🇬`,
  },
  {
    name: `Cook Islands`,
    dialCode: `+682`,
    isoCode: `CK`,
    flag: `🇨🇰`,
  },
  {
    name: `Costa Rica`,
    dialCode: `+506`,
    isoCode: `CR`,
    flag: `🇨🇷`,
  },
  {
    name: `Croatia`,
    dialCode: `+385`,
    isoCode: `HR`,
    flag: `🇭🇷`,
  },
  {
    name: `Cuba`,
    dialCode: `+53`,
    isoCode: `CU`,
    flag: `🇨🇺`,
  },
  {
    name: `Cyprus`,
    dialCode: `+357`,
    isoCode: `CY`,
    flag: `🇨🇾`,
  },
  {
    name: `Czech Republic`,
    dialCode: `+420`,
    isoCode: `CZ`,
    flag: `🇨🇿`,
  },
  {
    name: `Democratic Republic of the Congo`,
    dialCode: `+243`,
    isoCode: `CD`,
    flag: `🇨🇩`,
  },
  {
    name: `Denmark`,
    dialCode: `+45`,
    isoCode: `DK`,
    flag: `🇩🇰`,
  },
  {
    name: `Djibouti`,
    dialCode: `+253`,
    isoCode: `DJ`,
    flag: `🇩🇯`,
  },
  {
    name: `Dominica`,
    dialCode: `+1767`,
    isoCode: `DM`,
    flag: `🇩🇲`,
  },
  {
    name: `Dominican Republic`,
    dialCode: `+1849`,
    isoCode: `DO`,
    flag: `🇩🇴`,
  },
  {
    name: `Ecuador`,
    dialCode: `+593`,
    isoCode: `EC`,
    flag: `🇪🇨`,
  },
  {
    name: `Egypt`,
    dialCode: `+20`,
    isoCode: `EG`,
    flag: `🇪🇬`,
  },
  {
    name: `El Salvador`,
    dialCode: `+503`,
    isoCode: `SV`,
    flag: `🇸🇻`,
  },
  {
    name: `English`,
    dialCode: `+44`,
    isoCode: `EN`,
    flag: `🇬🇧`,
  },
  {
    name: `Equatorial Guinea`,
    dialCode: `+240`,
    isoCode: `GQ`,
    flag: `🇬🇶`,
  },
  {
    name: `Eritrea`,
    dialCode: `+291`,
    isoCode: `ER`,
    flag: `🇪🇷`,
  },
  {
    name: `Estonia`,
    dialCode: `+372`,
    isoCode: `EE`,
    flag: `🇪🇪`,
  },
  {
    name: `Eswatini`,
    dialCode: `+268`,
    isoCode: `SZ`,
    flag: `🇸🇿`,
  },
  {
    name: `Ethiopia`,
    dialCode: `+251`,
    isoCode: `ET`,
    flag: `🇪🇹`,
  },
  {
    name: `Falkland Islands (Malvinas)`,
    dialCode: `+500`,
    isoCode: `FK`,
    flag: `🇫🇰`,
  },
  {
    name: `Faroe Islands`,
    dialCode: `+298`,
    isoCode: `FO`,
    flag: `🇫🇴`,
  },
  {
    name: `Fiji`,
    dialCode: `+679`,
    isoCode: `FJ`,
    flag: `🇫🇯`,
  },
  {
    name: `Finland`,
    dialCode: `+358`,
    isoCode: `FI`,
    flag: `🇫🇮`,
  },
  {
    name: `France`,
    dialCode: `+33`,
    isoCode: `FR`,
    flag: `🇫🇷`,
  },
  {
    name: `French Guiana`,
    dialCode: `+594`,
    isoCode: `GF`,
    flag: `🇬🇫`,
  },
  {
    name: `French Polynesia`,
    dialCode: `+689`,
    isoCode: `PF`,
    flag: `🇵🇫`,
  },
  {
    name: `Gabon`,
    dialCode: `+241`,
    isoCode: `GA`,
    flag: `🇬🇦`,
  },
  {
    name: `Gambia`,
    dialCode: `+220`,
    isoCode: `GM`,
    flag: `🇬🇲`,
  },
  {
    name: `Georgia`,
    dialCode: `+995`,
    isoCode: `GE`,
    flag: `🇬🇪`,
  },
  {
    name: `Germany`,
    dialCode: `+49`,
    isoCode: `DE`,
    flag: `🇩🇪`,
  },
  {
    name: `Ghana`,
    dialCode: `+233`,
    isoCode: `GH`,
    flag: `🇬🇭`,
  },
  {
    name: `Gibraltar`,
    dialCode: `+350`,
    isoCode: `GI`,
    flag: `🇬🇮`,
  },
  {
    name: `Greece`,
    dialCode: `+30`,
    isoCode: `GR`,
    flag: `🇬🇷`,
  },
  {
    name: `Greenland`,
    dialCode: `+299`,
    isoCode: `GL`,
    flag: `🇬🇱`,
  },
  {
    name: `Grenada`,
    dialCode: `+1473`,
    isoCode: `GD`,
    flag: `🇬🇩`,
  },
  {
    name: `Guadeloupe`,
    dialCode: `+590`,
    isoCode: `GP`,
    flag: `🇬🇵`,
  },
  {
    name: `Guam`,
    dialCode: `+1671`,
    isoCode: `GU`,
    flag: `🇬🇺`,
  },
  {
    name: `Guatemala`,
    dialCode: `+502`,
    isoCode: `GT`,
    flag: `🇬🇹`,
  },
  {
    name: `Guernsey`,
    dialCode: `+44`,
    isoCode: `GG`,
    flag: `🇬🇬`,
  },
  {
    name: `Guinea`,
    dialCode: `+224`,
    isoCode: `GN`,
    flag: `🇬🇳`,
  },
  {
    name: `Guinea-Bissau`,
    dialCode: `+245`,
    isoCode: `GW`,
    flag: `🇬🇼`,
  },
  {
    name: `Guyana`,
    dialCode: `+592`,
    isoCode: `GY`,
    flag: `🇬🇾`,
  },
  {
    name: `Haiti`,
    dialCode: `+509`,
    isoCode: `HT`,
    flag: `🇭🇹`,
  },
  {
    name: `Holy See (Vatican City State)`,
    dialCode: `+379`,
    isoCode: `VA`,
    flag: `🇻🇦`,
  },
  {
    name: `Honduras`,
    dialCode: `+504`,
    isoCode: `HN`,
    flag: `🇭🇳`,
  },
  {
    name: `Hong Kong`,
    dialCode: `+852`,
    isoCode: `HK`,
    flag: `🇭🇰`,
  },
  {
    name: `Hungary`,
    dialCode: `+36`,
    isoCode: `HU`,
    flag: `🇭🇺`,
  },
  {
    name: `Iceland`,
    dialCode: `+354`,
    isoCode: `IS`,
    flag: `🇮🇸`,
  },
  {
    name: `India`,
    dialCode: `+91`,
    isoCode: `IN`,
    flag: `🇮🇳`,
  },
  {
    name: `Indonesia`,
    dialCode: `+62`,
    isoCode: `ID`,
    flag: `🇮🇩`,
  },
  {
    name: `Iran`,
    dialCode: `+98`,
    isoCode: `IR`,
    flag: `🇮🇷`,
  },
  {
    name: `Iraq`,
    dialCode: `+964`,
    isoCode: `IQ`,
    flag: `🇮🇶`,
  },
  {
    name: `Ireland`,
    dialCode: `+353`,
    isoCode: `IE`,
    flag: `🇮🇪`,
  },
  {
    name: `Isle of Man`,
    dialCode: `+44`,
    isoCode: `IM`,
    flag: `🇮🇲`,
  },
  {
    name: `Italy`,
    dialCode: `+39`,
    isoCode: `IT`,
    flag: `🇮🇹`,
  },
  {
    name: `Ivory Coast / Cote d'Ivoire`,
    dialCode: `+225`,
    isoCode: `CI`,
    flag: `🇨🇮`,
  },
  {
    name: `Jamaica`,
    dialCode: `+1876`,
    isoCode: `JM`,
    flag: `🇯🇲`,
  },
  {
    name: `Japan`,
    dialCode: `+81`,
    isoCode: `JP`,
    flag: `🇯🇵`,
  },
  {
    name: `Jersey`,
    dialCode: `+44`,
    isoCode: `JE`,
    flag: `🇯🇪`,
  },
  {
    name: `Jordan`,
    dialCode: `+962`,
    isoCode: `JO`,
    flag: `🇯🇴`,
  },
  {
    name: `Kazakhstan`,
    dialCode: `+77`,
    isoCode: `KZ`,
    flag: `🇰🇿`,
  },
  {
    name: `Kenya`,
    dialCode: `+254`,
    isoCode: `KE`,
    flag: `🇰🇪`,
  },
  {
    name: `Kiribati`,
    dialCode: `+686`,
    isoCode: `KI`,
    flag: `🇰🇮`,
  },
  {
    name: `Korea, Democratic People's Republic of Korea`,
    dialCode: `+850`,
    isoCode: `KP`,
    flag: `🇰🇵`,
  },
  {
    name: `Korea, Republic of South Korea`,
    dialCode: `+82`,
    isoCode: `KR`,
    flag: `🇰🇷`,
  },
  {
    name: `Kosovo`,
    dialCode: `+383`,
    isoCode: `XK`,
    flag: `🇽🇰`,
  },
  {
    name: `Kuwait`,
    dialCode: `+965`,
    isoCode: `KW`,
    flag: `🇰🇼`,
  },
  {
    name: `Kyrgyzstan`,
    dialCode: `+996`,
    isoCode: `KG`,
    flag: `🇰🇬`,
  },
  {
    name: `Laos`,
    dialCode: `+856`,
    isoCode: `LA`,
    flag: `🇱🇦`,
  },
  {
    name: `Latvia`,
    dialCode: `+371`,
    isoCode: `LV`,
    flag: `🇱🇻`,
  },
  {
    name: `Lebanon`,
    dialCode: `+961`,
    isoCode: `LB`,
    flag: `🇱🇧`,
  },
  {
    name: `Lesotho`,
    dialCode: `+266`,
    isoCode: `LS`,
    flag: `🇱🇸`,
  },
  {
    name: `Liberia`,
    dialCode: `+231`,
    isoCode: `LR`,
    flag: `🇱🇷`,
  },
  {
    name: `Libya`,
    dialCode: `+218`,
    isoCode: `LY`,
    flag: `🇱🇾`,
  },
  {
    name: `Liechtenstein`,
    dialCode: `+423`,
    isoCode: `LI`,
    flag: `🇱🇮`,
  },
  {
    name: `Lithuania`,
    dialCode: `+370`,
    isoCode: `LT`,
    flag: `🇱🇹`,
  },
  {
    name: `Luxembourg`,
    dialCode: `+352`,
    isoCode: `LU`,
    flag: `🇱🇺`,
  },
  {
    name: `Macau`,
    dialCode: `+853`,
    isoCode: `MO`,
    flag: `🇲🇴`,
  },
  {
    name: `Madagascar`,
    dialCode: `+261`,
    isoCode: `MG`,
    flag: `🇲🇬`,
  },
  {
    name: `Malawi`,
    dialCode: `+265`,
    isoCode: `MW`,
    flag: `🇲🇼`,
  },
  {
    name: `Malaysia`,
    dialCode: `+60`,
    isoCode: `MY`,
    flag: `🇲🇾`,
  },
  {
    name: `Maldives`,
    dialCode: `+960`,
    isoCode: `MV`,
    flag: `🇲🇻`,
  },
  {
    name: `Mali`,
    dialCode: `+223`,
    isoCode: `ML`,
    flag: `🇲🇱`,
  },
  {
    name: `Malta`,
    dialCode: `+356`,
    isoCode: `MT`,
    flag: `🇲🇹`,
  },
  {
    name: `Marshall Islands`,
    dialCode: `+692`,
    isoCode: `MH`,
    flag: `🇲🇭`,
  },
  {
    name: `Martinique`,
    dialCode: `+596`,
    isoCode: `MQ`,
    flag: `🇲🇶`,
  },
  {
    name: `Mauritania`,
    dialCode: `+222`,
    isoCode: `MR`,
    flag: `🇲🇷`,
  },
  {
    name: `Mauritius`,
    dialCode: `+230`,
    isoCode: `MU`,
    flag: `🇲🇺`,
  },
  {
    name: `Mayotte`,
    dialCode: `+262`,
    isoCode: `YT`,
    flag: `🇾🇹`,
  },
  {
    name: `Mexico`,
    dialCode: `+52`,
    isoCode: `MX`,
    flag: `🇲🇽`,
  },
  {
    name: `Micronesia, Federated States of Micronesia`,
    dialCode: `+691`,
    isoCode: `FM`,
    flag: `🇫🇲`,
  },
  {
    name: `Moldova`,
    dialCode: `+373`,
    isoCode: `MD`,
    flag: `🇲🇩`,
  },
  {
    name: `Monaco`,
    dialCode: `+377`,
    isoCode: `MC`,
    flag: `🇲🇨`,
  },
  {
    name: `Mongolia`,
    dialCode: `+976`,
    isoCode: `MN`,
    flag: `🇲🇳`,
  },
  {
    name: `Montenegro`,
    dialCode: `+382`,
    isoCode: `ME`,
    flag: `🇲🇪`,
  },
  {
    name: `Montserrat`,
    dialCode: `+1664`,
    isoCode: `MS`,
    flag: `🇲🇸`,
  },
  {
    name: `Morocco`,
    dialCode: `+212`,
    isoCode: `MA`,
    flag: `🇲🇦`,
  },
  {
    name: `Mozambique`,
    dialCode: `+258`,
    isoCode: `MZ`,
    flag: `🇲🇿`,
  },
  {
    name: `Myanmar`,
    dialCode: `+95`,
    isoCode: `MM`,
    flag: `🇲🇲`,
  },
  {
    name: `Namibia`,
    dialCode: `+264`,
    isoCode: `NA`,
    flag: `🇳🇦`,
  },
  {
    name: `Nauru`,
    dialCode: `+674`,
    isoCode: `NR`,
    flag: `🇳🇷`,
  },
  {
    name: `Nepal`,
    dialCode: `+977`,
    isoCode: `NP`,
    flag: `🇳🇵`,
  },
  {
    name: `Netherlands`,
    dialCode: `+31`,
    isoCode: `NL`,
    flag: `🇳🇱`,
  },
  {
    name: `Netherlands Antilles`,
    dialCode: `+599`,
    isoCode: `AN`,
    flag: `🇦🇳`,
  },
  {
    name: `New Caledonia`,
    dialCode: `+687`,
    isoCode: `NC`,
    flag: `🇳🇨`,
  },
  {
    name: `New Zealand`,
    dialCode: `+64`,
    isoCode: `NZ`,
    flag: `🇳🇿`,
  },
  {
    name: `Nicaragua`,
    dialCode: `+505`,
    isoCode: `NI`,
    flag: `🇳🇮`,
  },
  {
    name: `Niger`,
    dialCode: `+227`,
    isoCode: `NE`,
    flag: `🇳🇪`,
  },
  {
    name: `Nigeria`,
    dialCode: `+234`,
    isoCode: `NG`,
    flag: `🇳🇬`,
  },
  {
    name: `Niue`,
    dialCode: `+683`,
    isoCode: `NU`,
    flag: `🇳🇺`,
  },
  {
    name: `Norfolk Island`,
    dialCode: `+672`,
    isoCode: `NF`,
    flag: `🇳🇫`,
  },
  {
    name: `North Macedonia`,
    dialCode: `+389`,
    isoCode: `MK`,
    flag: `🇲🇰`,
  },
  {
    name: `Northern Mariana Islands`,
    dialCode: `+1670`,
    isoCode: `MP`,
    flag: `🇲🇵`,
  },
  {
    name: `Norway`,
    dialCode: `+47`,
    isoCode: `NO`,
    flag: `🇳🇴`,
  },
  {
    name: `Oman`,
    dialCode: `+968`,
    isoCode: `OM`,
    flag: `🇴🇲`,
  },
  {
    name: `Pakistan`,
    dialCode: `+92`,
    isoCode: `PK`,
    flag: `🇵🇰`,
  },
  {
    name: `Palau`,
    dialCode: `+680`,
    isoCode: `PW`,
    flag: `🇵🇼`,
  },
  {
    name: `Palestine`,
    dialCode: `+970`,
    isoCode: `PS`,
    flag: `🇵🇸`,
  },
  {
    name: `Panama`,
    dialCode: `+507`,
    isoCode: `PA`,
    flag: `🇵🇦`,
  },
  {
    name: `Papua New Guinea`,
    dialCode: `+675`,
    isoCode: `PG`,
    flag: `🇵🇬`,
  },
  {
    name: `Paraguay`,
    dialCode: `+595`,
    isoCode: `PY`,
    flag: `🇵🇾`,
  },
  {
    name: `Peru`,
    dialCode: `+51`,
    isoCode: `PE`,
    flag: `🇵🇪`,
  },
  {
    name: `Philippines`,
    dialCode: `+63`,
    isoCode: `PH`,
    flag: `🇵🇭`,
  },
  {
    name: `Pitcairn`,
    dialCode: `+872`,
    isoCode: `PN`,
    flag: `🇵🇳`,
  },
  {
    name: `Poland`,
    dialCode: `+48`,
    isoCode: `PL`,
    flag: `🇵🇱`,
  },
  {
    name: `Portugal`,
    dialCode: `+351`,
    isoCode: `PT`,
    flag: `🇵🇹`,
  },
  {
    name: `Puerto Rico`,
    dialCode: `+1939`,
    isoCode: `PR`,
    flag: `🇵🇷`,
  },
  {
    name: `Qatar`,
    dialCode: `+974`,
    isoCode: `QA`,
    flag: `🇶🇦`,
  },
  {
    name: `Reunion`,
    dialCode: `+262`,
    isoCode: `RE`,
    flag: `🇷🇪`,
  },
  {
    name: `Romania`,
    dialCode: `+40`,
    isoCode: `RO`,
    flag: `🇷🇴`,
  },
  {
    name: `Russia`,
    dialCode: `+7`,
    isoCode: `RU`,
    flag: `🇷🇺`,
  },
  {
    name: `Rwanda`,
    dialCode: `+250`,
    isoCode: `RW`,
    flag: `🇷🇼`,
  },
  {
    name: `Saint Barthelemy`,
    dialCode: `+590`,
    isoCode: `BL`,
    flag: `🇧🇱`,
  },
  {
    name: `Saint Helena, Ascension and Tristan Da Cunha`,
    dialCode: `+290`,
    isoCode: `SH`,
    flag: `🇸🇭`,
  },
  {
    name: `Saint Kitts and Nevis`,
    dialCode: `+1869`,
    isoCode: `KN`,
    flag: `🇰🇳`,
  },
  {
    name: `Saint Lucia`,
    dialCode: `+1758`,
    isoCode: `LC`,
    flag: `🇱🇨`,
  },
  {
    name: `Saint Martin`,
    dialCode: `+590`,
    isoCode: `MF`,
    flag: `🇲🇫`,
  },
  {
    name: `Saint Pierre and Miquelon`,
    dialCode: `+508`,
    isoCode: `PM`,
    flag: `🇵🇲`,
  },
  {
    name: `Saint Vincent and the Grenadines`,
    dialCode: `+1784`,
    isoCode: `VC`,
    flag: `🇻🇨`,
  },
  {
    name: `Samoa`,
    dialCode: `+685`,
    isoCode: `WS`,
    flag: `🇼🇸`,
  },
  {
    name: `San Marino`,
    dialCode: `+378`,
    isoCode: `SM`,
    flag: `🇸🇲`,
  },
  {
    name: `Sao Tome and Principe`,
    dialCode: `+239`,
    isoCode: `ST`,
    flag: `🇸🇹`,
  },
  {
    name: `Saudi Arabia`,
    dialCode: `+966`,
    isoCode: `SA`,
    flag: `🇸🇦`,
  },
  {
    name: `Senegal`,
    dialCode: `+221`,
    isoCode: `SN`,
    flag: `🇸🇳`,
  },
  {
    name: `Serbia`,
    dialCode: `+381`,
    isoCode: `RS`,
    flag: `🇷🇸`,
  },
  {
    name: `Seychelles`,
    dialCode: `+248`,
    isoCode: `SC`,
    flag: `🇸🇨`,
  },
  {
    name: `Sierra Leone`,
    dialCode: `+232`,
    isoCode: `SL`,
    flag: `🇸🇱`,
  },
  {
    name: `Singapore`,
    dialCode: `+65`,
    isoCode: `SG`,
    flag: `🇸🇬`,
  },
  {
    name: `Sint Maarten`,
    dialCode: `+1721`,
    isoCode: `SX`,
    flag: `🇸🇽`,
  },
  {
    name: `Slovakia`,
    dialCode: `+421`,
    isoCode: `SK`,
    flag: `🇸🇰`,
  },
  {
    name: `Slovenia`,
    dialCode: `+386`,
    isoCode: `SI`,
    flag: `🇸🇮`,
  },
  {
    name: `Solomon Islands`,
    dialCode: `+677`,
    isoCode: `SB`,
    flag: `🇸🇧`,
  },
  {
    name: `Somalia`,
    dialCode: `+252`,
    isoCode: `SO`,
    flag: `🇸🇴`,
  },
  {
    name: `South Africa`,
    dialCode: `+27`,
    isoCode: `ZA`,
    flag: `🇿🇦`,
  },
  {
    name: `South Georgia and the South Sandwich Islands`,
    dialCode: `+500`,
    isoCode: `GS`,
    flag: `🇬🇸`,
  },
  {
    name: `South Sudan`,
    dialCode: `+211`,
    isoCode: `SS`,
    flag: `🇸🇸`,
  },
  {
    name: `Spain`,
    dialCode: `+34`,
    isoCode: `ES`,
    flag: `🇪🇸`,
  },
  {
    name: `Sri Lanka`,
    dialCode: `+94`,
    isoCode: `LK`,
    flag: `🇱🇰`,
  },
  {
    name: `Sudan`,
    dialCode: `+249`,
    isoCode: `SD`,
    flag: `🇸🇩`,
  },
  {
    name: `Suriname`,
    dialCode: `+597`,
    isoCode: `SR`,
    flag: `🇸🇷`,
  },
  {
    name: `Svalbard and Jan Mayen`,
    dialCode: `+47`,
    isoCode: `SJ`,
    flag: `🇸🇯`,
  },
  {
    name: `Sweden`,
    dialCode: `+46`,
    isoCode: `SE`,
    flag: `🇸🇪`,
  },
  {
    name: `Switzerland`,
    dialCode: `+41`,
    isoCode: `CH`,
    flag: `🇨🇭`,
  },
  {
    name: `Syrian Arab Republic`,
    dialCode: `+963`,
    isoCode: `SY`,
    flag: `🇸🇾`,
  },
  {
    name: `Taiwan`,
    dialCode: `+886`,
    isoCode: `TW`,
    flag: `🇹🇼`,
  },
  {
    name: `Tajikistan`,
    dialCode: `+992`,
    isoCode: `TJ`,
    flag: `🇹🇯`,
  },
  {
    name: `Tanzania, United Republic of Tanzania`,
    dialCode: `+255`,
    isoCode: `TZ`,
    flag: `🇹🇿`,
  },
  {
    name: `Thailand`,
    dialCode: `+66`,
    isoCode: `TH`,
    flag: `🇹🇭`,
  },
  {
    name: `Timor-Leste`,
    dialCode: `+670`,
    isoCode: `TL`,
    flag: `🇹🇱`,
  },
  {
    name: `Togo`,
    dialCode: `+228`,
    isoCode: `TG`,
    flag: `🇹🇬`,
  },
  {
    name: `Tokelau`,
    dialCode: `+690`,
    isoCode: `TK`,
    flag: `🇹🇰`,
  },
  {
    name: `Tonga`,
    dialCode: `+676`,
    isoCode: `TO`,
    flag: `🇹🇴`,
  },
  {
    name: `Trinidad and Tobago`,
    dialCode: `+1868`,
    isoCode: `TT`,
    flag: `🇹🇹`,
  },
  {
    name: `Tunisia`,
    dialCode: `+216`,
    isoCode: `TN`,
    flag: `🇹🇳`,
  },
  {
    name: `Turkey`,
    dialCode: `+90`,
    isoCode: `TR`,
    flag: `🇹🇷`,
  },
  {
    name: `Turkmenistan`,
    dialCode: `+993`,
    isoCode: `TM`,
    flag: `🇹🇲`,
  },
  {
    name: `Turks and Caicos Islands`,
    dialCode: `+1649`,
    isoCode: `TC`,
    flag: `🇹🇨`,
  },
  {
    name: `Tuvalu`,
    dialCode: `+688`,
    isoCode: `TV`,
    flag: `🇹🇻`,
  },
  {
    name: `Uganda`,
    dialCode: `+256`,
    isoCode: `UG`,
    flag: `🇺🇬`,
  },
  {
    name: `Ukraine`,
    dialCode: `+380`,
    isoCode: `UA`,
    flag: `🇺🇦`,
  },
  {
    name: `United Arab Emirates`,
    dialCode: `+971`,
    isoCode: `AE`,
    flag: `🇦🇪`,
  },
  {
    name: `United Kingdom`,
    dialCode: `+44`,
    isoCode: `GB`,
    flag: `🇬🇧`,
  },
  {
    name: `United States`,
    dialCode: `+1`,
    isoCode: `US`,
    flag: `🇺🇸`,
  },
  {
    name: `Uruguay`,
    dialCode: `+598`,
    isoCode: `UY`,
    flag: `🇺🇾`,
  },
  {
    name: `Uzbekistan`,
    dialCode: `+998`,
    isoCode: `UZ`,
    flag: `🇺🇿`,
  },
  {
    name: `Vanuatu`,
    dialCode: `+678`,
    isoCode: `VU`,
    flag: `🇻🇺`,
  },
  {
    name: `Venezuela, Bolivarian Republic of Venezuela`,
    dialCode: `+58`,
    isoCode: `VE`,
    flag: `🇻🇪`,
  },
  {
    name: `Vietnam`,
    dialCode: `+84`,
    isoCode: `VN`,
    flag: `🇻🇳`,
  },
  {
    name: `Virgin Islands, British`,
    dialCode: `+1284`,
    isoCode: `VG`,
    flag: `🇻🇬`,
  },
  {
    name: `Virgin Islands, U.S.`,
    dialCode: `+1340`,
    isoCode: `VI`,
    flag: `🇻🇮`,
  },
  {
    name: `Wallis and Futuna`,
    dialCode: `+681`,
    isoCode: `WF`,
    flag: `🇼🇫`,
  },
  {
    name: `Yemen`,
    dialCode: `+967`,
    isoCode: `YE`,
    flag: `🇾🇪`,
  },
  {
    name: `Zambia`,
    dialCode: `+260`,
    isoCode: `ZM`,
    flag: `🇿🇲`,
  },
  {
    name: `Zimbabwe`,
    dialCode: `+263`,
    isoCode: `ZW`,
    flag: `🇿🇼`,
  },
]

export function getCountryCode(countryName: string): string {
  const country = nationality.find((o) =>
    new RegExp(countryName, `i`).test(o.name)
  )
  return country ? country.isoCode : ``
}

export const getFlagIcon = (isoCode: string) => {
  const country = nationality.find(
    (o) => o.isoCode.toLowerCase() === isoCode.toLowerCase()
  )
  return country ? country.flag : `🏳️`
}

export function getCountryName(
  isoCode: string,
  flagPosition: "start" | "end" = `end`
): string {
  const country = nationality.find((o) => o.isoCode === isoCode.toUpperCase())
  if (flagPosition === `start`) {
    return country ? `${country.flag} ${country.name}` : `🌎 Worldwide`
  }
  return country ? `${country.name} ${country.flag}` : `Worldwide 🌎`
}

export const getAllAvailableCountryCodes = () =>
  nationality.map((o) => o.isoCode)

export const getAllCountryNames = () => nationality.map((o) => o.name)

export const selectCountryOptions = (flagPosition: "start" | "end" = `end`) =>
  nationality.map((o) => ({
    value: o.isoCode,
    label:
      flagPosition === `start` ? `${o.flag} ${o.name}` : `${o.name} ${o.flag}`,
  }))
